import actions from '../action/home'
import CONSTANT from '../constant/home'

const billboardList = []
const recommendList = []
const bannerList = []
const shopList = []
const popularList = {
  topicId: '',
  list: []
}

export default {
  actions,
  state: {
    billboardList,
    recommendList,
    bannerList,
    shopList,
    popularList,
  },
  mutations: {
    [CONSTANT.BILLBOARDS_GET_LIST_SUCCESS] (state, list) {
      return state.billboardList = list || []
    },
    [CONSTANT.BILLBOARDS_GET_LIST_ERROR] (state, e) {
      return state.billboardList = []
    },
    [CONSTANT.RECOMMEND_GET_LIST_SUCCESS] (state, list) {
      return state.recommendList = list || []
    },
    [CONSTANT.RECOMMEND_GET_LIST_ERROR] (state, e) {
      return state.recommendList = []
    },
    [CONSTANT.BANNER_GET_LIST_SUCCESS] (state, list) {
      return state.bannerList = list || []
    },
    [CONSTANT.BANNER_GET_LIST_ERROR] (state, e) {
      return state.bannerList = []
    },
    [CONSTANT.SHOPS_GET_LIST_SUCCESS] (state, list) {
      return state.shopList = list || []
    },
    [CONSTANT.SHOPS_GET_LIST_ERROR] (state, e) {
      return state.shopList = []
    },
    [CONSTANT.POPULAR_GET_LIST_SUCCESS] (state, list) {
      return state.popularList = list || []
    },
    [CONSTANT.POPULAR_GET_LIST_ERROR] (state, e) {
      return state.popularList = {topicId: '', list: []}
    },
    [CONSTANT.HOME_GETTOPICGATHERLIST_SUCCESS] (state, data) {

    },
    [CONSTANT.HOME_GETTOPICGATHERLIST_ERROR] (state, e) {
    },
    [CONSTANT.HOME_GETHOMEMENUS_SUCCESS] (state, data) {

    },
    [CONSTANT.HOME_GETHOMEMENUS_ERROR] (state, e) {

    },
        /*yeoman-template-point-1*/
  }
}
